import backgroundJobHub from "@/hubs/backgroundJobHub";

export default{
  namespaced: true,
  state: {
    connection: null,
    jobs: [],
    jobsAvailable: false
  },
  getters: {
    jobsAvailable: state => {
      return state.jobs.length > 0
    }
  },
  mutations: {
    init(state, data) {
      state.jobs = data;
    },
    update(state, data) {
      state.jobs = data;
    }
  },
  actions: {
    init({commit}) {
      this.connection = backgroundJobHub.getConnection();
      this.connection.start().then(async () => {
        this.connection.on('JobUpdate', response => commit('update', response))
        this.connection.on('OnInit', response => commit('init', response))
        await this.connection.invoke("Init");
      });
    }
  }
}
